// Approximate town-centre coordinates for every Contentful service area, keyed
// by lower-case location name. Used only to pick the nearest served towns for
// the "Neighborhoods and Nearby Areas" section on city pages, so a few hundred
// metres of error does not matter. A town missing from this table simply gets
// no nearby-areas section; add it here when a new service area is created.
const cityCoordinates = {
  "wyoming": [42.9134, -85.7053],
  "ada": [42.9553, -85.4953],
  "allegan": [42.5292, -85.8553],
  "allendale": [42.9725, -85.9528],
  "alto": [42.8506, -85.3797],
  "athens": [42.0889, -85.2342],
  "bailey": [43.2878, -85.8164],
  "battle creek": [42.3212, -85.1797],
  "bellevue": [42.4434, -85.018],
  "bradley": [42.6406, -85.6458],
  "byron center": [42.8122, -85.7228],
  "caledonia": [42.7892, -85.5164],
  "cannonsburg": [43.0136, -85.49],
  "cedar springs": [43.2234, -85.5514],
  "charlotte": [42.5636, -84.8358],
  "comstock park": [43.0384, -85.67],
  "conklin": [43.1406, -85.8486],
  "coopersville": [43.0639, -85.9348],
  "coral": [43.362, -85.38],
  "delton": [42.4972, -85.4086],
  "dorr": [42.7281, -85.7214],
  "douglas": [42.6434, -86.2006],
  "east leroy": [42.1928, -85.2281],
  "fennville": [42.5939, -86.1042],
  "ferrysburg": [43.0847, -86.2203],
  "freeport": [42.7661, -85.3122],
  "fruitport": [43.1317, -86.1548],
  "galesburg": [42.2884, -85.418],
  "gowen": [43.2214, -85.3333],
  "grand haven": [43.0631, -86.2284],
  "grand rapids": [42.9634, -85.6681],
  "grandville": [42.9097, -85.7631],
  "grant": [43.3353, -85.8106],
  "hamilton": [42.6886, -86.0003],
  "hastings": [42.6489, -85.2908],
  "hickory corners": [42.457, -85.395],
  "holland": [42.7875, -86.1089],
  "hopkins": [42.6206, -85.7614],
  "howard city": [43.3959, -85.4681],
  "jackson": [42.2459, -84.4013],
  "kalamazoo": [42.2917, -85.5872],
  "kent city": [43.2203, -85.7509],
  "lake odessa": [42.7845, -85.1386],
  "lowell": [42.9334, -85.342],
  "marshall": [42.2723, -84.9633],
  "middleville": [42.7131, -85.462],
  "moline": [42.7406, -85.665],
  "muskegon": [43.2342, -86.2484],
  "pierson": [43.3156, -85.5],
  "plainwell": [42.4401, -85.6489],
  "portage": [42.2012, -85.58],
  "richland": [42.377, -85.4553],
  "rockford": [43.12, -85.56],
  "sand lake": [43.2925, -85.5164],
  "shelbyville": [42.605, -85.6261],
  "sparta": [43.1606, -85.71],
  "texas corners": [42.235, -85.7072],
  "trufant": [43.3139, -85.3517],
  "vicksburg": [42.12, -85.5328],
  "wayland": [42.6739, -85.6447],
};

const toRad = (deg) => (deg * Math.PI) / 180;

// Great-circle distance in miles.
const milesBetween = ([lat1, lng1], [lat2, lng2]) => {
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 3958.8 * 2 * Math.asin(Math.sqrt(a));
};

// The nearest served towns to `city`, closest first, as { name, zips } entries
// for CityNeighborhoods. Returns [] when the city has no coordinates.
const nearbyServiceAreas = (city, cities, limit = 8) => {
  const key = String(city).trim().toLowerCase();
  const origin = cityCoordinates[key];
  if (!origin) return [];

  return (cities || [])
    .map((edge) => edge && edge.node)
    .filter((node) => node && node.location)
    .map((node) => {
      const name = String(node.location).trim();
      const coords = cityCoordinates[name.toLowerCase()];
      return coords && name.toLowerCase() !== key
        ? { name, zips: node.zipCodes || undefined, miles: milesBetween(origin, coords) }
        : null;
    })
    .filter(Boolean)
    .sort((a, b) => a.miles - b.miles)
    .slice(0, limit)
    .map(({ name, zips }) => ({ name, zips }));
};

module.exports = { cityCoordinates, nearbyServiceAreas };
